module.exports = function() {
  return new Worker(__webpack_public_path__ + "3a65c8a5a8ee0a84f59f.worker.js");
};